import { Outlet } from "react-router-dom";
import {NavBar} from "./Navbar/NavBar";
import React from "react";
import {DebugTokenPanel} from "./DebugTokenPanel";

export function Layout() {
    return (
        <div className="page">
            <DebugTokenPanel />
            <NavBar/>

            <div className="page-wrapper bg-transparent">
                <Outlet/>
            </div>
        </div>
    )
}

